<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{'REQUIRED_FIELD' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div class="row container-fluid pr-0">
    <div class="col-md-12 pr-0">
        <mat-dialog-content class="contentPadding">
            <p>{{'EXPORT_TO_PROPOSAL_REQUIRED_DIALOGBOX_DATA_1' | translate}}</p>
            <p>{{'EXPORT_TO_PROPOSAL_REQUIRED_DIALOGBOX_DATA_2' | translate}}</p>

            <div [formGroup]="requiredFieldForm" class="required-fields-form">
                <div class="form-row">
                    <label for="name" class="field-label">{{'EXPORT_PROPOSAL_REQUIRED_NAME_LABEL' | translate}}</label>
                    <mat-form-field appearance="outline" class="field-input">
                        <input matInput id="name" formControlName="name" [placeholder]="'EXPORT_PROPOSAL_REQUIRED_NAME_PLACEHOLDER' | translate">
                        <mat-error *ngIf="requiredFieldForm.controls.name.hasError('required')">
                            {{'EXPORT_PROPOSAL_REQUIRED_NAME_REQUIRED' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row">
                    <label for="email" class="field-label">{{'EXPORT_PROPOSAL_REQUIRED_EMAIL_LABEL' | translate}}</label>
                    <mat-form-field appearance="outline" class="field-input">
                        <input matInput id="email" formControlName="email" [placeholder]="'EXPORT_PROPOSAL_REQUIRED_EMAIL_PLACEHOLDER' | translate">
                        <mat-error *ngIf="requiredFieldForm.controls.email.hasError('required')">
                            {{'EXPORT_PROPOSAL_REQUIRED_EMAIL_REQUIRED' | translate}}
                        </mat-error>
                        <mat-error
                            *ngIf="requiredFieldForm.controls.email.hasError('email') && !requiredFieldForm.controls.email.hasError('required')">
                            {{'EXPORT_PROPOSAL_REQUIRED_EMAIL_INVALID' | translate}}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="actionsPadding">
            <div>
                <button class="openCloseBtn" mat-raised-button color="primary" (click)="onSubmit()"
                    [disabled]="requiredFieldForm.invalid">
                    {{'COMMON_DIALOGS_BTN_LABELS_OK' | translate}}
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</div>